module.exports = __webpack_public_path__ + "static/media/ico_simulation_nose_bridge.716faab5.png";